<script setup>
import {
  ref,
  unref,
  provide,
  computed,
  watch,
  onMounted,
  onUnmounted,
} from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import {
  useMapGetter,
  useFunctionGetter,
} from 'dashboard/composables/store.js';

// BonBoZ: thanh dau da gop thang vao file upstream (bo tab, them o tim kieu
// Pancake + o mau loc theo the + loc theo trang/nhom).
import ChatListHeader from 'dashboard/components/ChatListHeader.vue';
import ZaloCuocTroChuyenMoi from 'dashboard/components/ZaloCuocTroChuyenMoi.vue';
import { hopThuZaloChoNut } from 'dashboard/helper/zaloKetBan';
import TrangMatKetNoiDialog from 'dashboard/routes/dashboard/mainPage/TrangMatKetNoiDialog.vue';
import LocNhanh from 'dashboard/components/QuickFilters.vue';
import ConversationList from './ConversationList.vue';
import Dialog from 'dashboard/components-next/dialog/Dialog.vue';
import ConversationFilter from 'next/filter/ConversationFilter.vue';
import SaveCustomView from 'next/filter/SaveCustomView.vue';
import DeleteCustomViews from 'dashboard/routes/dashboard/customviews/DeleteCustomViews.vue';
import ConversationBulkActions from './widgets/conversation/conversationBulkActions/Index.vue';
import TeleportWithDirection from 'dashboard/components-next/TeleportWithDirection.vue';
import ConversationResolveAttributesModal from 'dashboard/components-next/ConversationWorkflow/ConversationResolveAttributesModal.vue';

import { useAlert } from 'dashboard/composables';
import { useBulkActions } from 'dashboard/composables/chatlist/useBulkActions';
import { useFilter } from 'shared/composables/useFilter';
import { useTrack } from 'dashboard/composables';
import { useI18n } from 'vue-i18n';
import {
  useCamelCase,
  useSnakeCase,
} from 'dashboard/composables/useTransformKeys';
import { useEmitter } from 'dashboard/composables/emitter';
import { useConversationRequiredAttributes } from 'dashboard/composables/useConversationRequiredAttributes';
import { watchDebounced, useWindowSize } from '@vueuse/core';
import { khopTimKiem } from 'dashboard/helper/timHoiThoai';
import { useSelectedPages } from 'dashboard/composables/useSelectedPages';

import wootConstants from 'dashboard/constants/globals';
import { emitter } from 'shared/helpers/mitt';
import { SU_KIEN_LOC, SU_KIEN_DUNG_LAI } from 'dashboard/helper/quickFilters';
import {
  dateFilterFromQuery,
  useDateFilterMode,
} from 'dashboard/composables/useDateFilterMode';
import BaoVe from 'dashboard/components/ErrorBoundary.vue';
import advancedFilterOptions from './widgets/conversation/advancedFilterItems';
import filterQueryGenerator from '../helper/filterQueryGenerator.js';
import languages from 'dashboard/components/widgets/conversation/advancedFilterItems/languages';
import countries from 'shared/constants/countries';
import { generateValuesForEditCustomViews } from 'dashboard/helper/customViewsHelper';
import { conversationListPageURL } from '../helper/URLHelper';
import {
  isOnMentionsView,
  isOnParticipatingView,
  isOnUnattendedView,
} from '../store/modules/conversations/helpers/actionHelpers';
import {
  getUserPermissions,
  filterItemsByPermission,
} from 'dashboard/helper/permissionsHelper.js';
import { matchesFilters } from '../store/modules/conversations/helpers/filterHelpers';
import {
  resolveInboxFilter,
  sortComparator,
  isUnseen,
  lastActivityAt,
  SORT_UNSEEN_FIRST,
} from '../store/modules/conversations/helpers';
import { CONVERSATION_EVENTS } from '../helper/AnalyticsHelper/events';
import { ASSIGNEE_TYPE_TAB_PERMISSIONS } from 'dashboard/constants/permissions.js';

const props = defineProps({
  conversationInbox: { type: [String, Number], default: 0 },
  teamId: { type: [String, Number], default: 0 },
  label: { type: String, default: '' },
  conversationType: { type: String, default: '' },
  foldersId: { type: [String, Number], default: 0 },
  showConversationList: { default: true, type: Boolean },
  isOnExpandedLayout: { default: false, type: Boolean },
});

const emit = defineEmits(['conversationLoad']);
const { t } = useI18n();
const router = useRouter();
const route = useRoute();
const store = useStore();

const resolveAttributesModalRef = ref(null);

// BonBoZ: mo may ra phai thay TAT CA hoi thoai. Mac dinh cua upstream la ME,
// nen nguoi moi vao thay danh sach gan nhu trong roi tuong he thong hong.
const activeAssigneeTab = ref(wootConstants.ASSIGNEE_TYPE.ALL);
// BonBoZ: hien MOI hoi thoai, khong loc theo trang thai. Truc page can thay
// het roi tu quyet dinh, khong phai nho doi tab moi thay khach cu quay lai.
const activeStatus = ref(wootConstants.STATUS_TYPE.ALL);
// BonBoZ: tu khoa tim, go o ngay tren danh sach
const tuKhoaTim = ref('');
// BonBoZ: tu khoa DA CHOT de gui len server, khac voi `tuKhoaTim` la chu dang go.
// Go toi dau hoi server toi do thi moi ky tu la mot truy van; cho 300ms sau khi
// ngung go, va duoi 2 ky tu thi chua hoi - index trigram gan nhu vo dung o do.
const tuKhoaGuiLen = ref('');
// BonBoZ: 'identity' (mac dinh) hoac 'content' — xem `Conversations::SearchScope`.
const cheDoTim = ref('identity');
// Che do noi dung can 3 ky tu: index trigram chi phat huy tu do. Tang danh tinh
// dung 2 vi bang khach nho hon nhieu lan.
const toiThieuTim = () => (cheDoTim.value === 'content' ? 3 : 2);
// BonBoZ: dieu kien cua nut loc nhanh dang bat o thanh trai, gui kem moi lan
// hoi server. Rong = khong loc. Phan lang nghe dat o cuoi file - cac ham no goi
// khai bao ben duoi.
const boLocNhanh = ref({});

// Huy hieu "gio tao" tren the hoi thoai bam theo BO LOC DANH SACH DANG DUNG.
// `immediate` lo luon lan dung dau tien: danh sach moi thi chua loc gi, huy
// hieu phai tat - ke ca khi phien truoc vua loc theo ngay tao.
const { setDateFilter } = useDateFilterMode();
watch(
  boLocNhanh,
  loc => {
    const { mode, active } = dateFilterFromQuery(loc);
    setDateFilter(mode, active);
  },
  { immediate: true }
);
// BonBoZ: dung `v-if` chu KHONG phai `md:hidden` cho dai loc ngang. Bang chon
// cua no teleport ra ngoai the boc, nen an bang CSS thi ban mobile bien mat ma
// BANG cua no o lai giua man desktop — mot dai trang vat ngang khong dong duoc.
const { width: beNgangMan } = useWindowSize();
const laDienThoai = computed(
  () => beNgangMan.value < wootConstants.SMALL_SCREEN_BREAKPOINT
);
// BonBoZ: mac dinh day hoi thoai chua xem len dau. Server sap (finder
// 'unread_first') nen dung ca ngoai 25 hoi thoai da tai.
const activeSortBy = ref(SORT_UNSEEN_FIRST);
const showAdvancedFilters = ref(false);
// chatsOnView is to store the chats that are currently visible on the screen,
// which mirrors the conversationList.
const chatsOnView = ref([]);
const foldersQuery = ref({});
const showAddFoldersModal = ref(false);
const showDeleteFoldersModal = ref(false);
const appliedFilter = ref([]);
const advancedFilterTypes = ref(
  advancedFilterOptions.map(filter => ({
    ...filter,
    attributeName: t(`FILTER.ATTRIBUTES.${filter.attributeI18nKey}`),
  }))
);

const currentUser = useMapGetter('getCurrentUser');
const chatLists = useMapGetter('getFilteredConversations');
const mineChatsList = useMapGetter('getMineChats');
const allChatList = useMapGetter('getAllStatusChats');
const unAssignedChatsList = useMapGetter('getUnAssignedChats');
const participatingChatsList = useMapGetter('getParticipatingChats');
const chatListLoading = useMapGetter('getChatListLoadingStatus');
const selectedChat = useMapGetter('getSelectedChat');
const activeInbox = useMapGetter('getSelectedInbox');
const conversationStats = useMapGetter('conversationStats/getStats');
const appliedFilters = useMapGetter('getAppliedConversationFiltersV2');
const folders = useMapGetter('customViews/getConversationCustomViews');
const agentList = useMapGetter('agents/getAgents');
const teamsList = useMapGetter('teams/getTeams');
const inboxesList = useMapGetter('inboxes/getInboxes');
const campaigns = useMapGetter('campaigns/getAllCampaigns');
const labels = useMapGetter('labels/getLabels');
const currentAccountId = useMapGetter('getCurrentAccountId');
// We can't useFunctionGetter here since it needs to be called on setup?
const getTeamFn = useMapGetter('teams/getTeam');
const getConversationById = useMapGetter('getConversationById');

const {
  selectedConversations,
  selectedInboxes,
  selectConversation,
  deSelectConversation,
  selectAllConversations,
  resetBulkActions,
  isConversationSelected,
  onAssignAgent,
  onAssignLabels,
  onRemoveLabels,
} = useBulkActions();

const {
  initializeStatusAndAssigneeFilterToModal,
  initializeInboxTeamAndLabelFilterToModal,
} = useFilter({
  filteri18nKey: 'FILTER',
  attributeModel: 'conversation_attribute',
});

const { checkMissingAttributes } = useConversationRequiredAttributes();

// BonBoZ: lua chon trang o Bang dieu khien, dung chung mot hop dong.
const {
  selectedInboxIds,
  isAllSelected,
  matchesSelection,
  setSelectedInboxes,
} = useSelectedPages();

// BonBoZ: panel "Cuộc trò chuyện mới" Zalo — xem luật ở hopThuZaloChoNut.
const tatCaHopThu = useMapGetter('inboxes/getInboxes');
const hopThuZalo = computed(() =>
  hopThuZaloChoNut(
    tatCaHopThu.value,
    selectedInboxIds.value,
    selectedChat.value?.inbox_id
  )
);
const moPanelZalo = ref(false);

// MO MOT TRANG CHINH LA CHON TRANG. Bam the o Bang dieu khien, hay doi trang o
// thanh ben, deu dan toi route co `inbox_id` — ghi lai lua chon do de nhung man
// hinh KHONG co inbox tren duong dan (ro nhat la phan Thong ke) van biet dang
// xem trang nao. Truoc day chi hop thoai "Gop trang" ghi, ma luong that thi
// khong ai di qua no, nen Thong ke luon hien so cua ca hai trang.
//
// Khong dong toi khi dang o "tat ca hoi thoai" (`inbox_id` rong): lua chon
// nhieu trang dat o hop thoai Gop trang phai con nguyen.
watch(
  () => props.conversationInbox,
  id => {
    const so = Number(id);
    if (!so) return;
    const dang = selectedInboxIds.value;
    if (dang.length === 1 && dang[0] === so) return;
    setSelectedInboxes([so]);
  },
  { immediate: true }
);

// computed

const hasAppliedFilters = computed(() => {
  return appliedFilters.value.length !== 0;
});

const activeFolder = computed(() => {
  if (props.foldersId) {
    const activeView = folders.value.filter(
      view => view.id === Number(props.foldersId)
    );
    const [firstValue] = activeView;
    return firstValue;
  }
  return undefined;
});

const getContact = useMapGetter('contacts/getContact');
const folderContactId = useMapGetter('customViews/getActiveFolderContactId');

const activeFolderName = computed(() => {
  return activeFolder.value?.name;
});

const hasActiveFolders = computed(() => {
  return Boolean(activeFolder.value && props.foldersId !== 0);
});

const hasAppliedFiltersOrActiveFolders = computed(() => {
  return hasAppliedFilters.value || hasActiveFolders.value;
});

const currentUserDetails = computed(() => {
  const { id, name } = currentUser.value;
  return { id, name };
});

const userPermissions = computed(() => {
  return getUserPermissions(currentUser.value, currentAccountId.value);
});

const assigneeTabItems = computed(() => {
  return filterItemsByPermission(
    ASSIGNEE_TYPE_TAB_PERMISSIONS,
    userPermissions.value,
    item => item.permissions
  ).map(({ key, count: countKey }) => ({
    key,
    name: t(`CHAT_LIST.ASSIGNEE_TYPE_TABS.${key}`),
    count: conversationStats.value[countKey] || 0,
  }));
});

// BonBoZ: KHONG hien nguoi phu trach tren the hoi thoai. Chatwoot hien no o
// tab "Tat ca" va khi co bo loc; voi doi truc page nho, hang do chi lam the
// cao them mot dong ma khong ai doc — ai phu trach da co o dau hoi thoai va
// cot phai. Giu computed de cho goi ben duoi khong doi.
const showAssigneeInConversationCard = computed(() => false);

const currentPageFilterKey = computed(() => {
  return hasAppliedFiltersOrActiveFolders.value
    ? 'appliedFilters'
    : activeAssigneeTab.value;
});

const inbox = useFunctionGetter('inboxes/getInbox', activeInbox);
const currentPage = useFunctionGetter(
  'conversationPage/getCurrentPageFilter',
  activeAssigneeTab
);
const currentFiltersPage = useFunctionGetter(
  'conversationPage/getCurrentPageFilter',
  currentPageFilterKey
);
const hasCurrentPageEndReached = useFunctionGetter(
  'conversationPage/getHasEndReached',
  currentPageFilterKey
);

const conversationCustomAttributes = useFunctionGetter(
  'attributes/getAttributesByModel',
  'conversation_attribute'
);

const activeAssigneeTabCount = computed(() => {
  const count = assigneeTabItems.value.find(
    item => item.key === activeAssigneeTab.value
  ).count;
  return count;
});

const conversationListPagination = computed(() => {
  const conversationsPerPage = 25;
  const hasChatsOnView =
    chatsOnView.value &&
    Array.isArray(chatsOnView.value) &&
    !chatsOnView.value.length;
  const isNoFiltersOrFoldersAndChatListNotEmpty =
    !hasAppliedFiltersOrActiveFolders.value && hasChatsOnView;
  const isUnderPerPage =
    chatsOnView.value.length < conversationsPerPage &&
    activeAssigneeTabCount.value < conversationsPerPage &&
    activeAssigneeTabCount.value > chatsOnView.value.length;

  if (isNoFiltersOrFoldersAndChatListNotEmpty && isUnderPerPage) {
    return 1;
  }

  return currentPage.value + 1;
});

const conversationFilters = computed(() => {
  return {
    // BonBoZ: ngoai pham vi mot inbox thi de server loc theo trang da chon
    // (API nhan inbox_id[]), nho vay so dem tren tab cung chi tinh trang do.
    inboxId: resolveInboxFilter(
      props.conversationInbox,
      selectedInboxIds.value
    ),
    assigneeType: activeAssigneeTab.value,
    status: activeStatus.value,
    sortBy: activeSortBy.value,
    q: tuKhoaGuiLen.value || undefined,
    searchMode: cheDoTim.value === 'content' ? 'content' : undefined,
    page: conversationListPagination.value,
    labels: props.label ? [props.label] : undefined,
    // Loc nhanh o thanh trai. Dat SAU `labels` de nhom tag ghi de duoc bo loc
    // nhan cua route, va truoc `teamId` chi vi thu tu doc cho de.
    ...boLocNhanh.value,
    teamId: props.teamId || undefined,
    conversationType: props.conversationType || undefined,
  };
});

const activeTeam = computed(() => {
  if (props.teamId) {
    return getTeamFn.value(props.teamId);
  }
  return {};
});

// BonBoZ: hoi thoai dang mo giu nguyen cho cho toi khi nguoi doc roi di.
//
// Thu tu chua-xem-len-dau doi ngay khi khach nhan hay khi minh vua doc xong, nen
// the dang doc tu nhien truot khoi cho - bam nham hoi thoai ben canh la chuyen
// thuong xuyen. Khoa lai bang cach giu nguyen khoa sap xep cua no tu luc mo:
// hoi thoai khac van chen len tren dung thu tu, rieng no dung yen. Roi sang the
// khac la no ve dung cho ngay.
const pinnedSortKey = ref(null);

const sortKeyFor = chat =>
  pinnedSortKey.value?.id === chat.id
    ? pinnedSortKey.value
    : { unseen: isUnseen(chat), activity: lastActivityAt(chat) };

const compareForList = (a, b) => {
  const keyA = sortKeyFor(a);
  const keyB = sortKeyFor(b);
  return keyB.unseen - keyA.unseen || keyB.activity - keyA.activity;
};

// Chot lai cho khi doi hoi thoai, va khi vua bam "danh dau chua doc" tren chinh
// hoi thoai dang mo - do la thao tac co chu y, the phai nhay len dau ngay. Con
// lai (mo ra doc nen het chua xem, hoac co tin moi) thi giu nguyen cho.
watch(
  () => [selectedChat.value?.id, isUnseen(selectedChat.value)],
  ([id, unseen], previous) => {
    if (!id) {
      pinnedSortKey.value = null;
      return;
    }
    if (id !== previous?.[0] || unseen) {
      pinnedSortKey.value = {
        id,
        unseen,
        activity: lastActivityAt(selectedChat.value),
      };
    }
  },
  { immediate: true }
);

function filterByAssigneeTab(conversations) {
  if (activeAssigneeTab.value === wootConstants.ASSIGNEE_TYPE.ME) {
    return conversations.filter(
      c => c.meta?.assignee?.id === currentUser.value?.id
    );
  }
  if (activeAssigneeTab.value === wootConstants.ASSIGNEE_TYPE.UNASSIGNED) {
    return conversations.filter(c => !c.meta?.assignee);
  }
  return [...conversations];
}

const conversationList = computed(() => {
  let localConversationList = [];

  if (!hasAppliedFiltersOrActiveFolders.value) {
    const filters = conversationFilters.value;
    if (
      props.conversationType === wootConstants.CONVERSATION_TYPE.PARTICIPATING
    ) {
      localConversationList = filterByAssigneeTab(
        participatingChatsList.value(filters)
      );
    } else if (activeAssigneeTab.value === 'me') {
      localConversationList = [...mineChatsList.value(filters)];
    } else if (activeAssigneeTab.value === 'unassigned') {
      localConversationList = [...unAssignedChatsList.value(filters)];
    } else {
      localConversationList = [...allChatList.value(filters)];
    }
  } else {
    localConversationList = [...chatLists.value];
  }

  if (activeFolder.value) {
    const { payload } = activeFolder.value.query;
    localConversationList = localConversationList.filter(conversation => {
      return matchesFilters(conversation, payload);
    });
  }

  // BonBoZ: hai luoi chan cho hoi thoai den qua ActionCable. Chung KHONG di qua
  // truy van API nen khong mang theo bo loc nao ca - khong chan thi hoi thoai
  // cua trang minh khong truc, hoac khach khong khop tu khoa, van nhay vao
  // danh sach khi co tin moi.
  //
  // Day KHONG phai loc tai cho nhu truoc: server da tra ve dung tap ket qua,
  // luoi nay chi gat nhung the di lac vao. Loc lai ca danh sach o may chinh la
  // thu gay ra canh nhap nhay - xem `Conversations::SearchScope`.
  if (!isAllSelected.value) {
    localConversationList = localConversationList.filter(matchesSelection);
  }

  // Che do NOI DUNG: khop nam trong tin nhan, khong nam o danh tinh — loc lai o
  // day se xoa sach ket qua server vua tra ve. Xem issue #24.
  if (tuKhoaGuiLen.value && cheDoTim.value !== 'content') {
    localConversationList = localConversationList.filter(hoiThoai =>
      khopTimKiem(hoiThoai, tuKhoaGuiLen.value)
    );
  }

  // BonBoZ: sap lai o CLIENT chu khong chi tin thu tu server tra ve. Tin den qua
  // ActionCable duoc `push` vao cuoi mang state (index.js), khong co gi day no
  // len - khong sap o day thi hoi thoai vua co tin moi nam lai duoi day cho toi
  // lan fetch sau. Sap tren ban sao (`localConversationList` da la mang moi),
  // khong dung vao mang cua state, neu khong virtualizer lai giat.
  if (activeSortBy.value !== SORT_UNSEEN_FIRST) {
    return localConversationList.sort((a, b) =>
      sortComparator(a, b, activeSortBy.value)
    );
  }
  return localConversationList.sort(compareForList);
});

// BonBoZ: KHONG hien dong "Tat ca cac cuoc tro chuyen da duoc tai".
// Danh sach het la thay het - them mot dong chuc mung o cuoi chi ton mot dong
// va lam nguoi doc tuong con gi do phai lam.
const showEndOfListMessage = computed(() => false);

const allConversationsSelected = computed(() => {
  return (
    conversationList.value.length === selectedConversations.value.length &&
    conversationList.value.every(el =>
      selectedConversations.value.includes(el.id)
    )
  );
});

const uniqueInboxes = computed(() => {
  return [...new Set(selectedInboxes.value)];
});

// ---------------------- Methods -----------------------
function datBoLocMacDinh() {
  // BonBoZ: BO QUA ca `status` LAN `order_by` da luu trong uiSettings.
  //
  // Ca hai bo loc deu da bi go khoi giao dien — `ConversationBasicFilter.vue`,
  // cho duy nhat ghi `order_by`, khong con duoc mount o dau. Nen ai tung luu mot
  // gia tri truoc do la MAC KET vinh vien, khong con nut nao doi lai.
  //
  // Truoc day chi bo qua `status`; `order_by` van doc tu cau hinh cu nen tai
  // khoan nao con luu `last_activity_at_desc` thi mat han viec day hoi thoai
  // chua xem len dau — nhin nhu tinh nang bi hong, ma that ra la mot gia tri
  // rot lai tu thoi con nut sap xep. Da gap that ngay 09/09/2026 tren local.
  //
  // Hai bo loc nay gio la HANG SO cua san pham, khong phai lua chon cua tung
  // nguoi: xem het moi trang thai, va hoi thoai chua xem len dau.
  activeStatus.value = wootConstants.STATUS_TYPE.ALL;
  activeSortBy.value = SORT_UNSEEN_FIRST;
}

function emitConversationLoaded() {
  emit('conversationLoad');
}

function fetchFilteredConversations(payload) {
  payload = useSnakeCase(payload);
  let page = currentFiltersPage.value + 1;
  store
    .dispatch('fetchFilteredConversations', {
      queryData: filterQueryGenerator(payload),
      page,
    })
    .then(emitConversationLoaded);

  showAdvancedFilters.value = false;
}

function fetchSavedFilteredConversations(payload) {
  payload = useSnakeCase(payload);
  let page = currentFiltersPage.value + 1;
  store
    .dispatch('fetchFilteredConversations', {
      queryData: payload,
      page,
    })
    .then(emitConversationLoaded);
}

function onApplyFilter(payload) {
  payload = useSnakeCase(payload);
  resetBulkActions();
  foldersQuery.value = filterQueryGenerator(payload);
  store.dispatch('conversationPage/reset');
  store.dispatch('emptyAllConversations');
  fetchFilteredConversations(payload);
}

function closeAdvanceFiltersModal() {
  showAdvancedFilters.value = false;
  appliedFilter.value = [];
}

function onUpdateSavedFilter(payload, folderName) {
  const transformedPayload = useSnakeCase(payload);
  const payloadData = {
    ...unref(activeFolder),
    name: unref(folderName),
    query: filterQueryGenerator(transformedPayload),
  };
  store.dispatch('customViews/update', payloadData);
  closeAdvanceFiltersModal();
}

function onClickOpenAddFoldersModal() {
  showAddFoldersModal.value = true;
}

function onCloseAddFoldersModal() {
  showAddFoldersModal.value = false;
}

function onClickOpenDeleteFoldersModal() {
  showDeleteFoldersModal.value = true;
}

function onCloseDeleteFoldersModal() {
  showDeleteFoldersModal.value = false;
}

function setParamsForEditFolderModal() {
  // Here we are setting the params for edit folder modal to show the existing values.

  // For agent, team, inboxes,and campaigns we get only the id's from the query.
  // So we are mapping the id's to the actual values.

  // For labels we get the name of the label from the query.
  // If we delete the label from the label list then we will not be able to show the label name.

  // For custom attributes we get only attribute key.
  // So we are mapping it to find the input type of the attribute to show in the edit folder modal.
  return {
    agents: agentList.value,
    teams: teamsList.value,
    inboxes: inboxesList.value,
    labels: labels.value,
    campaigns: campaigns.value,
    contacts: [getContact.value(folderContactId.value)],
    languages: languages,
    countries: countries,
    priority: [
      { id: 'low', name: t('CONVERSATION.PRIORITY.OPTIONS.LOW') },
      { id: 'medium', name: t('CONVERSATION.PRIORITY.OPTIONS.MEDIUM') },
      { id: 'high', name: t('CONVERSATION.PRIORITY.OPTIONS.HIGH') },
      { id: 'urgent', name: t('CONVERSATION.PRIORITY.OPTIONS.URGENT') },
    ],
    filterTypes: advancedFilterTypes.value,
    allCustomAttributes: conversationCustomAttributes.value,
  };
}

function initializeExistingFilterToModal() {
  const statusFilter = initializeStatusAndAssigneeFilterToModal(
    activeStatus.value,
    currentUserDetails.value,
    activeAssigneeTab.value
  );
  // TODO: Remove the usage of useCamelCase after migrating useFilter to camelcase
  if (statusFilter) {
    appliedFilter.value = [...appliedFilter.value, useCamelCase(statusFilter)];
  }

  // TODO: Remove the usage of useCamelCase after migrating useFilter to camelcase
  const otherFilters = initializeInboxTeamAndLabelFilterToModal(
    props.conversationInbox,
    inbox.value,
    props.teamId,
    activeTeam.value,
    props.label
  ).map(useCamelCase);

  appliedFilter.value = [...appliedFilter.value, ...otherFilters];
}

function initializeFolderToFilterModal(newActiveFolder) {
  // Here we are setting the params for edit folder modal.
  //  To show the existing values. when we click on edit folder button.

  // Here we get the query from the active folder.
  // And we are mapping the query to the actual values.
  // To show in the edit folder modal by the help of generateValuesForEditCustomViews helper.
  const query = unref(newActiveFolder)?.query?.payload;
  if (!Array.isArray(query)) return;

  const newFilters = query.map(filter => {
    const transformed = useCamelCase(filter);
    const values = Array.isArray(transformed.values)
      ? generateValuesForEditCustomViews(
          useSnakeCase(filter),
          setParamsForEditFolderModal()
        )
      : [];

    return {
      attributeKey: transformed.attributeKey,
      attributeModel: transformed.attributeModel,
      customAttributeType: transformed.customAttributeType,
      filterOperator: transformed.filterOperator,
      queryOperator: transformed.queryOperator ?? 'and',
      values,
    };
  });

  appliedFilter.value = [...appliedFilter.value, ...newFilters];
}

function initalizeAppliedFiltersToModal() {
  appliedFilter.value = [...appliedFilters.value];
}

function onToggleAdvanceFiltersModal() {
  if (showAdvancedFilters.value === true) {
    closeAdvanceFiltersModal();
    return;
  }

  if (!hasAppliedFilters.value && !hasActiveFolders.value) {
    initializeExistingFilterToModal();
  }
  if (hasActiveFolders.value) {
    initializeFolderToFilterModal(activeFolder.value);
  }
  if (hasAppliedFilters.value) {
    initalizeAppliedFiltersToModal();
  }

  showAdvancedFilters.value = true;
}

// BonBoZ: ĐẶT ĐÈ, không gộp thêm.
//
// `updateChatListFilters` gộp kiểu `{ ...cũ, ...mới }`. Bỏ một bộ lọc nhanh thì
// khoá của nó biến MẤT khỏi object gửi xuống chứ không mang giá trị rỗng — gộp
// vào là giá trị cũ sống sót. Hậu quả: bấm "Xoá lọc" xong danh sách vẫn ra đúng
// kết quả vừa lọc, và bộ lọc đó bám theo sang mọi trang khác vì kho Vuex sống
// xuyên suốt phiên làm việc. Dính mọi bộ lọc nhanh, không riêng lọc ngày.
//
// `conversationFilters` đã là TOÀN BỘ điều kiện đang muốn, nên đặt đè mới đúng
// nghĩa. Khoá duy nhất nằm ngoài nó là `updatedWithin` của ReconnectService —
// cái đó tự đặt rồi tự xoá quanh một lần gọi, không chờ ở đây.
function fetchConversations() {
  store.dispatch('setChatListFilters', conversationFilters.value);
  store.dispatch('fetchAllConversations').then(emitConversationLoaded);
}

function resetAndFetchData() {
  appliedFilter.value = [];
  resetBulkActions();
  store.dispatch('conversationPage/reset');
  store.dispatch('emptyAllConversations');
  store.dispatch('clearConversationFilters');
  if (hasActiveFolders.value) {
    const payload = activeFolder.value.query;
    fetchSavedFilteredConversations(payload);
  }
  if (props.foldersId) {
    return;
  }
  fetchConversations();
}

function loadMoreConversations() {
  if (hasCurrentPageEndReached.value || chatListLoading.value) {
    return;
  }

  if (!hasAppliedFiltersOrActiveFolders.value) {
    fetchConversations();
  } else if (hasActiveFolders.value) {
    const payload = activeFolder.value.query;
    fetchSavedFilteredConversations(payload);
  } else if (hasAppliedFilters.value) {
    fetchFilteredConversations(appliedFilters.value);
  }
}

function openLastSavedItemInFolder() {
  const lastItemOfFolder = folders.value[folders.value.length - 1];
  const lastItemId = lastItemOfFolder.id;
  router.push({
    name: 'folder_conversations',
    params: { id: lastItemId },
  });
}

function openLastItemAfterDeleteInFolder() {
  if (folders.value.length > 0) {
    openLastSavedItemInFolder();
  } else {
    router.push({ name: 'home' });
    fetchConversations();
  }
}

function redirectToConversationList() {
  const {
    params: { accountId, inbox_id: inboxId, label, teamId },
    name,
  } = route;

  let conversationType = '';
  if (isOnMentionsView({ route: { name } })) {
    conversationType = wootConstants.CONVERSATION_TYPE.MENTION;
  } else if (isOnParticipatingView({ route: { name } })) {
    conversationType = wootConstants.CONVERSATION_TYPE.PARTICIPATING;
  } else if (isOnUnattendedView({ route: { name } })) {
    conversationType = wootConstants.CONVERSATION_TYPE.UNATTENDED;
  }
  router.push(
    conversationListPageURL({
      accountId,
      conversationType: conversationType,
      customViewId: props.foldersId,
      inboxId,
      label,
      teamId,
    })
  );
}

async function assignPriority(priority, conversationId = null) {
  store.dispatch('setCurrentChatPriority', {
    priority,
    conversationId,
  });
  store.dispatch('assignPriority', { conversationId, priority }).then(() => {
    useTrack(CONVERSATION_EVENTS.CHANGE_PRIORITY, {
      newValue: priority,
      from: 'Context menu',
    });
    useAlert(
      t('CONVERSATION.PRIORITY.CHANGE_PRIORITY.SUCCESSFUL', {
        priority,
        conversationId,
      })
    );
  });
}

async function onAssignTeam(team, conversationId = null) {
  try {
    await store.dispatch('assignTeam', {
      conversationId,
      teamId: team.id,
    });
    useAlert(
      t('CONVERSATION.CARD_CONTEXT_MENU.API.TEAM_ASSIGNMENT.SUCCESFUL', {
        team: team.name,
        conversationId,
      })
    );
  } catch (error) {
    useAlert(t('CONVERSATION.CARD_CONTEXT_MENU.API.TEAM_ASSIGNMENT.FAILED'));
  }
}

function toggleConversationStatus(
  conversationId,
  status,
  snoozedUntil,
  customAttributes = null
) {
  const payload = {
    conversationId,
    status,
    snoozedUntil,
  };

  if (customAttributes) {
    payload.customAttributes = customAttributes;
  }

  store.dispatch('toggleStatus', payload).then(() => {
    useAlert(t('CONVERSATION.CHANGE_STATUS'));
  });
}

function handleResolveConversation(conversationId, status, snoozedUntil) {
  if (status !== wootConstants.STATUS_TYPE.RESOLVED) {
    toggleConversationStatus(conversationId, status, snoozedUntil);
    return;
  }

  // Check for required attributes before resolving
  const conversation = getConversationById.value(conversationId);
  const currentCustomAttributes = conversation?.custom_attributes || {};
  const { hasMissing, missing } = checkMissingAttributes(
    currentCustomAttributes
  );

  if (hasMissing) {
    // Pass conversation context through the modal's API
    const conversationContext = {
      id: conversationId,
      snoozedUntil,
    };
    resolveAttributesModalRef.value?.open(
      missing,
      currentCustomAttributes,
      conversationContext
    );
  } else {
    toggleConversationStatus(conversationId, status, snoozedUntil);
  }
}

function handleResolveWithAttributes({ attributes, context }) {
  if (context) {
    const existingConversation = getConversationById.value(context.id);
    const currentCustomAttributes =
      existingConversation?.custom_attributes || {};
    const mergedAttributes = { ...currentCustomAttributes, ...attributes };

    toggleConversationStatus(
      context.id,
      wootConstants.STATUS_TYPE.RESOLVED,
      context.snoozedUntil,
      mergedAttributes
    );
  }
}

function allSelectedConversationsStatus(status) {
  if (!selectedConversations.value.length) return false;
  return selectedConversations.value.every(item => {
    return getConversationById.value(item)?.status === status;
  });
}

function toggleSelectAll(check) {
  selectAllConversations(check, conversationList);
}

useEmitter('fetch_conversation_stats', () => {
  if (hasAppliedFiltersOrActiveFolders.value) return;
  store.dispatch('conversationStats/get', conversationFilters.value);
});

onMounted(() => {
  // Danh sach dung lai tu dau, khong mang theo bo loc nao — bao cho thanh loc
  // o thanh trai tu tat, vi no song xuyen suot cac route va khong tu biet.
  emitter.emit(SU_KIEN_DUNG_LAI);
  store.dispatch('setChatListFilters', conversationFilters.value);
  datBoLocMacDinh();
  store.dispatch('setChatStatusFilter', activeStatus.value);
  store.dispatch('setChatSortFilter', activeSortBy.value);
  resetAndFetchData();
  if (hasActiveFolders.value) {
    store.dispatch('campaigns/get');
  }
});

const deleteConversationDialogRef = ref(null);
const selectedConversationId = ref(null);

async function deleteConversation() {
  try {
    await store.dispatch('deleteConversation', selectedConversationId.value);
    redirectToConversationList();
    selectedConversationId.value = null;
    deleteConversationDialogRef.value.close();
    useAlert(t('CONVERSATION.SUCCESS_DELETE_CONVERSATION'));
  } catch (error) {
    useAlert(t('CONVERSATION.FAIL_DELETE_CONVERSATION'));
  }
}

const handleDelete = conversationId => {
  selectedConversationId.value = conversationId;
  deleteConversationDialogRef.value.open();
};

provide('selectConversation', selectConversation);
provide('deSelectConversation', deSelectConversation);
provide('assignAgent', onAssignAgent);
provide('assignTeam', onAssignTeam);
provide('assignLabels', onAssignLabels);
provide('removeLabels', onRemoveLabels);
provide('updateConversationStatus', handleResolveConversation);
provide('assignPriority', assignPriority);
provide('isConversationSelected', isConversationSelected);
provide('deleteConversation', handleDelete);

watch(activeTeam, () => resetAndFetchData());

watch(
  computed(() => props.conversationInbox),
  () => resetAndFetchData()
);
watch(
  computed(() => props.label),
  () => resetAndFetchData()
);
watch(
  computed(() => props.conversationType),
  () => resetAndFetchData()
);

watch(activeFolder, (newVal, oldVal) => {
  if (newVal !== oldVal) {
    store.dispatch('customViews/setActiveConversationFolder', newVal || null);
  }
  resetAndFetchData();
});

// BonBoZ: go xong moi hoi server. Doi tu khoa la doi bo dieu kien, nen phai xoa
// danh sach cu va hoi lai tu trang 1 - dung luong `resetAndFetchData` san co khi
// doi trang hay doi tab, khong phai duong rieng.
watchDebounced(
  tuKhoaTim,
  tu => {
    const chuoi = tu.trim();
    const moi = chuoi.length >= toiThieuTim() ? chuoi : '';
    if (moi === tuKhoaGuiLen.value) return;

    tuKhoaGuiLen.value = moi;
    resetAndFetchData();
  },
  { debounce: 300 }
);

watch(chatLists, () => {
  chatsOnView.value = conversationList.value;
});

watch(conversationFilters, (newVal, oldVal) => {
  if (newVal !== oldVal) {
    store.dispatch('setChatListFilters', newVal);
  }
});

// BonBoZ: nhan lenh loc tu thanh trai. Dat cuoi file vi no goi
// resetBulkActions/fetchConversations - khai bao ben tren.
const nhanLocNhanh = ({ kieu, giaTri, truyVan }) => {
  if (kieu === 'nguoi') {
    activeAssigneeTab.value = giaTri;
    resetBulkActions();
    if (!currentPage.value) fetchConversations();
    return;
  }
  // Doi dieu kien la doi tap ket qua, khong phai loc bot tap dang co: phai xoa
  // danh sach cu va hoi lai tu trang 1, giong het luc doi tu khoa tim.
  boLocNhanh.value = truyVan || {};
  resetAndFetchData();
};
// Doi tang tim la doi bo dieu kien: phai hoi lai tu trang 1, va phai kiem lai
// nguong ky tu vi hai tang doi so ky tu khac nhau.
const doiCheDoTim = gia => {
  cheDoTim.value = gia;
  const chuoi = tuKhoaTim.value.trim();
  tuKhoaGuiLen.value = chuoi.length >= toiThieuTim() ? chuoi : '';
  resetAndFetchData();
};

emitter.on(SU_KIEN_LOC, nhanLocNhanh);
onUnmounted(() => emitter.off(SU_KIEN_LOC, nhanLocNhanh));
</script>

<template>
  <!-- BonBoZ: `min-w-0` de cot khong bi noi dung nong ra. Cot la flex item co
       `flex-shrink-0`, ma `min-width` mac dinh la `auto` = be ngang toi thieu
       cua NOI DUNG. Dai loc ngang (chi co tren dien thoai) rong 632px theo noi
       dung, keo ca cot len 632px roi bi the <main> ben ngoai (overflow-hidden)
       cat o 390 — dai loc khong con gi de cuon va vai muc bi khuat vinh vien,
       danh sach hoi thoai cung bi cat theo. Do duoc 09/09/2026: bo `min-w-0`
       thi cot 632, co thi cot 390 va dai cuon dung. -->
  <div
    class="flex relative flex-col flex-shrink-0 min-w-0 conversations-list-wrap bg-n-surface-1"
    :class="[
      { hidden: !showConversationList },
      // BonBoZ: 312 / 352 / 392. Ban dau 280 / 320 / 360 (hep hon upstream
      // 340 / 412) vi doi truc phan anh danh sach an het cho khung chat; sau
      // do lai phan anh the hoi thoai chat choi so voi Pancake (10/09/2026) —
      // noi them 32px, van hep hon upstream. Doi ba so nay thi doi luon ba so
      // be ngang o logo trong TopBar.vue (= 112 + be ngang cot).
      isOnExpandedLayout
        ? 'basis-full'
        : 'w-[312px] 2xl:w-[352px] 3xl:w-[392px]',
    ]"
  >
    <slot />
    <BaoVe ten="ChatListHeader">
      <ChatListHeader
        :has-applied-filters="hasAppliedFilters"
        :has-active-folders="hasActiveFolders"
        :co-nut-zalo="!!hopThuZalo"
        @add-folders="onClickOpenAddFoldersModal"
        @delete-folders="onClickOpenDeleteFoldersModal"
        @filters-modal="onToggleAdvanceFiltersModal"
        @reset-filters="resetAndFetchData"
        @tim="tuKhoaTim = $event"
        @doi-che-do-tim="doiCheDoTim"
        @mo-zalo="moPanelZalo = true"
      />
    </BaoVe>
    <ZaloCuocTroChuyenMoi
      v-if="moPanelZalo && hopThuZalo"
      :inbox="hopThuZalo"
      @close="moPanelZalo = false"
    />
    <!-- BonBoZ: popup khi trang trong phạm vi đang xem vừa mất kết nối. -->
    <TrangMatKetNoiDialog nghe-realtime />

    <!-- BonBoZ: loc nhanh cho DIEN THOAI. Ban doc song o thanh trai, ma thanh
         trai bi an duoi 768px — thieu cho nay thi truc page tren dien thoai chi
         xem duoc hang "tat ca", khong loc duoc "chua phan cong" hay theo tag.
         Cung mot component, dat ngang; no noi voi danh sach qua `SU_KIEN_LOC`
         nen dat o dau cung chay. -->
    <BaoVe v-if="laDienThoai" ten="LocNhanhNgang">
      <LocNhanh ngang class="shrink-0 border-b border-n-weak" />
    </BaoVe>

    <TeleportWithDirection
      v-if="showAddFoldersModal"
      to="#saveFilterTeleportTarget"
    >
      <SaveCustomView
        v-model="appliedFilter"
        :custom-views-query="foldersQuery"
        :open-last-saved-item="openLastSavedItemInFolder"
        @close="onCloseAddFoldersModal"
      />
    </TeleportWithDirection>

    <DeleteCustomViews
      v-if="showDeleteFoldersModal"
      v-model:show="showDeleteFoldersModal"
      :active-custom-view="activeFolder"
      :custom-views-id="foldersId"
      :open-last-item-after-delete="openLastItemAfterDeleteInFolder"
      @close="onCloseDeleteFoldersModal"
    />

    <p
      v-if="!chatListLoading && !conversationList.length"
      class="flex overflow-auto justify-center items-center p-4"
    >
      {{ $t('CHAT_LIST.LIST.404') }}
    </p>
    <ConversationBulkActions
      :conversations="selectedConversations"
      :all-conversations-selected="allConversationsSelected"
      :selected-inboxes="uniqueInboxes"
      :show-open-action="allSelectedConversationsStatus('open')"
      :show-resolved-action="allSelectedConversationsStatus('resolved')"
      :show-snoozed-action="allSelectedConversationsStatus('snoozed')"
      :class="isOnExpandedLayout && 'sm:!w-[24rem] !w-full'"
      @select-all-conversations="toggleSelectAll"
    />
    <ConversationList
      :conversation-list="conversationList"
      :is-loading="chatListLoading"
      :show-end-of-list-message="showEndOfListMessage"
      :label="label"
      :team-id="teamId"
      :folders-id="foldersId"
      :conversation-type="conversationType"
      :show-assignee="showAssigneeInConversationCard"
      :is-on-expanded-layout="isOnExpandedLayout"
      @load-more="loadMoreConversations"
    />
    <Dialog
      ref="deleteConversationDialogRef"
      type="alert"
      :title="
        $t('CONVERSATION.DELETE_CONVERSATION.TITLE', {
          conversationId: selectedConversationId,
        })
      "
      :description="$t('CONVERSATION.DELETE_CONVERSATION.DESCRIPTION')"
      :confirm-button-label="$t('CONVERSATION.DELETE_CONVERSATION.CONFIRM')"
      @confirm="deleteConversation"
      @close="selectedConversationId = null"
    />
    <TeleportWithDirection
      v-if="showAdvancedFilters"
      to="#conversationFilterTeleportTarget"
    >
      <ConversationFilter
        v-model="appliedFilter"
        :folder-name="activeFolderName"
        :is-folder-view="hasActiveFolders"
        @apply-filter="onApplyFilter"
        @update-folder="onUpdateSavedFilter"
        @close="closeAdvanceFiltersModal"
      />
    </TeleportWithDirection>
    <ConversationResolveAttributesModal
      ref="resolveAttributesModalRef"
      @submit="handleResolveWithAttributes"
    />
  </div>
</template>
